import React, { Component } from 'react';
import ReliefFormComponent from './ReliefFormComponent';
import { FORM_PORTAL_CONTROLLER_URL } from '../../actions/settings';
import '../../css/styles.css'

class ReliefForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            saveResponse: "",
            success: false,
            error: false,
            //branches:[{"branchId":"5","branchName":"GALLE BRANCH"},{"branchId":"2","branchName":"CITY OFFICE"},{"branchId":"3","branchName":"FOREIGN BRANCH"},{"branchId":"4","branchName":"KANDY BRANCH"},{"branchId":"6","branchName":"JAFFNA BRANCH"},{"branchId":"7","branchName":"MATARA BRANCH"},{"branchId":"8","branchName":"MATALE BRANCH"},{"branchId":"9","branchName":"GALEWELA BRANCH"},{"branchId":"10","branchName":"WELLAWATTE BRANCH"},{"branchId":"11","branchName":"KOLLUPITIYA BRANCH"},{"branchId":"12","branchName":"KOTAHENA BRANCH"},{"branchId":"13","branchName":"NEGOMBO BRANCH"},{"branchId":"14","branchName":"HIKKADUWA BRANCH"},{"branchId":"15","branchName":"HINGURAKGODA BRANCH"},{"branchId":"16","branchName":"KURUNEGALA BRANCH"},{"branchId":"17","branchName":"OLD MOOR STREET BRANCH"},{"branchId":"18","branchName":"MAHARAGAMA BRANCH"},{"branchId":"19","branchName":"BORELLA BRANCH"},{"branchId":"20","branchName":"NUGEGODA BRANCH"},{"branchId":"21","branchName":"KEGALLE BRANCH"},{"branchId":"22","branchName":"NARAHENPITA BRANCH"},{"branchId":"23","branchName":"MUTWAL BRANCH"},{"branchId":"29","branchName":"BATTARAMULLA BRANCH"},{"branchId":"31","branchName":"KANDANA BRANCH"},{"branchId":"24","branchName":"PETTAH BRANCH"},{"branchId":"25","branchName":"FTZ KATUNAYAKE BRANCH"},{"branchId":"26","branchName":"WENNAPPUWA BRANCH"},{"branchId":"27","branchName":"GALLE CITY BRANCH"},{"branchId":"28","branchName":"KOGGALA BRANCH"},{"branchId":"30","branchName":"EMBILIPITIYA BRANCH"}],
            branches: [],
            refNo: "",
            wave:"",
            circular:""
        }
    }
    saveForm = (json) => {
        this.saveReliefForm(json)
    }
     resetErrorState=()=>{
        this.setState({ error: false });
     }
saveReliefForm(data) {
    
    this.setState({ loading: true });
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' ,'withCredentials':true, 'Authorization':'Basic:' + btoa('mora' + ':' + 'combank@123!')},
        //headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    fetch(FORM_PORTAL_CONTROLLER_URL + 'cbcwebforms/savemoratorium', requestOptions)
        .then( async response => {
            const data =  await response.json();

                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data && data.message) || response.status;
                    this.setState({ loading: false ,error: true});
                    return Promise.reject(error);
    
                } else {
                    this.setState({ loading: false, success: true, refNo: data.reference });

                }
        })
        .catch(error => {
            this.setState({ loading: false });
            this.setState({ error: true });
        });
  }


     componentDidMount() {
 
        const requestOptions = {
            method: 'GET',
           // headers: { 'Content-Type': 'application/json' ,'withCredentials':true, 'Authorization':'Basic ' + btoa('admin' + ':' + 'admin')},
           headers: { 'Content-Type': 'application/json' },
            
        };
        fetch(FORM_PORTAL_CONTROLLER_URL +'cbcwebforms/getbranchlist', requestOptions)
        .then(async response => {
            const data = await response.json();
            // check for error response
            if (!response.ok) {
                const error = (data && data.message) || response.status;
                this.setState({ loading: false });
                this.setState({ error: true });
                return Promise.reject(error);

            } else {

                this.setState({
                    loading: false,
                    branches: data.branches,
                });

            }
        })
        .catch(error => {
            this.setState({ loading: false });
            this.setState({ error: true });

            console.error('There was an error=>branch!');
            
            
    });
//**get wave**//
//cbcwebforms
    fetch(FORM_PORTAL_CONTROLLER_URL +'cbcwebforms/getwave', requestOptions)
    .then(async response => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
            const error = (data && data.message) || response.status;
            this.setState({ loading: false });
            this.setState({ error: true });
            return Promise.reject(error);

        } else {

            this.setState({
                loading: false,
                wave: data.wave
            });

        }
    })
    .catch(error => {
        this.setState({ loading: false });
        this.setState({ error: true });

        console.error('There was an error=>getwave!');
        
        
});

//**get circular**//
fetch(FORM_PORTAL_CONTROLLER_URL +'cbcwebforms/getcircular', requestOptions)
.then(async response => {
    const data = await response.json();
    // check for error response
    if (!response.ok) {
        const error = (data && data.message) || response.status;
        this.setState({ loading: false });
        this.setState({ error: true });
        return Promise.reject(error);

    } else {

        this.setState({
            loading: false,
            circular: data.circular
        });

    }
})
.catch(error => {
    this.setState({ loading: false });
    this.setState({ error: true });

    console.error('There was an error=>circular!');
    
    
});
    
}


    render() {
        return (
            <div>
                <ReliefFormComponent
                    saveForm={this.saveForm}
                    loading={this.state.loading}
                    success={this.state.success}
                    error={this.state.error}
                    refNo={this.state.refNo}
                    branches={this.state.branches}
                    resetErrorState={this.resetErrorState}
                    wave={this.state.wave}
                    circular={this.state.circular}
                />
            </div>
        );
    }
}


export default ReliefForm;